<template>
  <el-card
    v-if="downloadStore.tasks.length && !minimized"
    class="download-progress-float"
    shadow="always"
  >
    <div style="min-width: 200px; max-width: 320px;">
      <div class="minimize-btn" @click="minimized = true">
        <el-icon><Minus /></el-icon>
      </div>
      <div class="close-btn" @click="downloadStore.clearAll()">
        <el-icon><Close /></el-icon>
      </div>
      <div v-for="task in downloadStore.tasks" :key="task.id" class="task-row">
        <div class="task-header">
          <span class="task-name" :title="task.name">{{ task.name }}</span>
          <el-icon v-if="task.status==='success'" color="var(--color-success)"><Check /></el-icon>
          <el-icon v-if="task.status==='error'" color="var(--color-danger)"><Close /></el-icon>
          <el-icon v-if="task.status==='cancelled'" color="#909399"><CircleClose /></el-icon>
          <el-button
            v-if="task.status==='downloading'"
            size="small"
            link
            @click="downloadStore.cancelTask(task.id)"
          >取消</el-button>
          <el-button
            v-if="task.status!=='downloading'"
            size="small"
            link
            @click="downloadStore.removeTask(task.id)"
          >移除</el-button>
        </div>
        <div class="progress-row">
          <el-progress
            :percentage="task.progress"
            :status="task.status==='error'?'exception':(task.status==='success'?'success':undefined)"
            :stroke-width="8"
            :show-text="false"
            class="task-progress"
          />
          <span v-if="task.status==='downloading'" class="speed-text">{{ task.speed }}</span>
        </div>
        <div v-if="task.status==='error' && task.error" class="error-text" :title="task.error">
          {{ task.error }}
        </div>
      </div>
    </div>
  </el-card>
  <!-- 最小化悬浮球 -->
  <div
    v-if="downloadStore.tasks.length && minimized"
    class="download-float-pill"
    @click="onPillClick"
    title="点击展开下载列表"
  >
    <span class="pill-content">
      <el-icon v-if="hasDownloading" class="pill-loading"><Loading /></el-icon>
      <span class="pill-text">{{ finishedCount }}/{{ totalCount }}</span>
    </span>
    <span class="pill-close-btn" @click.stop="downloadStore.clearAll()">
      <el-icon><Close /></el-icon>
    </span>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useDownloadStore } from '@/store/modules/download'
import { Check, Close, CircleClose, Minus, Loading } from '@element-plus/icons-vue'
const downloadStore = useDownloadStore()
const minimized = ref(false)
const totalCount = computed(() => downloadStore.tasks.length)
const finishedCount = computed(() =>
  downloadStore.tasks.filter(t => t.status === 'success').length
)
const hasDownloading = computed(() =>
  downloadStore.tasks.some(t => t.status === 'downloading')
)
const onPillClick = (e) => {
  if (e.target.closest('.pill-close-btn')) return;
  minimized.value = false;
};
</script>

<style scoped>
.download-progress-float {
  position: fixed;
  right: 24px;
  bottom: 80px;
  z-index: 3000;
  box-shadow: 0 2px 12px rgba(0,0,0,0.12);
  border-radius: 8px;
  padding: 10px 14px 10px 14px;
  background: #fff;
  min-width: 200px;
  max-width: 320px;
  pointer-events: auto;
}
.task-row {
  margin-bottom: 6px;
}
.task-header {
  display: flex;
  align-items: center;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 6px;
}
.progress-row {
  display: flex;
  align-items: center;
  margin-top: 2px;
}
.task-progress {
  flex: 1;
  margin-bottom: 0;
}
.speed-text {
  margin-left: 8px;
  color: #409EFF;
  font-size: 12px;
  min-width: 60px;
  text-align: right;
}
.error-text {
  margin-top: 4px;
  color: var(--color-danger);
  font-size: 12px;
  line-height: 1.4;
  word-break: break-word;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.minimize-btn {
  position: absolute;
  top: 6px;
  right: 34px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  z-index: 10;
}
.close-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  z-index: 11;
}
.download-float-pill {
  position: fixed;
  right: 32px;
  bottom: 80px;
  min-width: 70px;
  height: 40px;
  background: #409EFF;
  color: #fff;
  border-radius: 999px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  z-index: 3001;
  user-select: none;
  transition: background 0.2s;
  overflow: visible;
  padding: 0 12px 0 16px;
}
.pill-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
}
.pill-loading {
  margin-right: 4px;
  font-size: 20px;
  animation: spin 1s linear infinite;
  vertical-align: middle;
  flex-shrink: 0;
}
.pill-text {
  font-size: 1.1em;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1;
  display: inline-block;
  min-width: 24px;
  max-width: 48px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: clamp(12px, 1.1em, 20px);
}
.pill-close-btn {
  margin-left: 10px;
  width: 22px;
  height: 22px;
  background: rgba(0,0,0,0.10);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  z-index: 3;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  opacity: 0.7;
  pointer-events: auto;
  transition: background 0.2s, opacity 0.2s;
}
.pill-close-btn:hover {
  background: rgba(0,0,0,0.22);
  opacity: 1;
}
@keyframes spin {
  100% { transform: rotate(360deg);}
}
</style> 